import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';

import {UserAction} from 'AppAction';

import Dispatcher from 'service/Dispatcher';
import CacheService from 'service/CacheService';
import AppConstants from 'AppConstants';

const Session = new Immutable.Record({
			user: null,
			createdDate: null,
			token: null,
			expiresOn: null
});

class SessionStore extends ReduceStore {
	constructor() {
		super(Dispatcher);
	}

	getInitialState() {
		try {
			this.USER_SESSION_CACHE = "User_Session";

			let sessionJson = JSON.parse(CacheService.get(this.USER_SESSION_CACHE));
			const session = new Session(sessionJson);

			const expiresOn = session.get('expiresOn');
			const currentTime = new Date().getTime();
			if(expiresOn === null || currentTime > expiresOn) {
				CacheService.remove(this.USER_SESSION_CACHE);
				CacheService.remove(AppConstants.USER_ADDRESS_KEY);
				return new Session();//return empty session
			}

			return session;
		} catch(error) {
			console.log("Session Init State error", error);
			return new Session();//return empty session
		}
	}

	getCurrentSession() {
		if(!this.getState())
			return null;

		return this.getState().user === null? null: this.getState();
	}

	_updateUser(updatedUser) {
		const newState = this.getState().set('user', updatedUser);
		CacheService.save(this.USER_SESSION_CACHE, JSON.stringify(newState.toJSON()), true);
		return new Session(newState.toJS());
	}

	reduce(state, action) {
		switch(action.type) {
			case UserAction.LOGIN_SUCCESS:
				let sessionJson = {user: action.user, token: action.token, createdDate: new Date(), expiresOn: action.expiresOn};
				CacheService.save(this.USER_SESSION_CACHE, JSON.stringify(sessionJson), true);
				return new Session(sessionJson);
				
			case UserAction.LOGOUT:
				CacheService.remove(this.USER_SESSION_CACHE);
				CacheService.remove(AppConstants.USER_ADDRESS_KEY);
				return new Session();

			case UserAction.USER_UPDATE:
				const sessJson = {user: action.user, token: action.token, createdDate: new Date()};
				CacheService.save(this.USER_SESSION_CACHE, JSON.stringify(sessJson), true);
				return new Session(sessJson);
			case UserAction.PHONE_UPDATE:
				let phoneUpdatedUser = this.getState().user;
				phoneUpdatedUser.phoneNumber = action.phoneNumber;

				return this._updateUser(phoneUpdatedUser);
			case UserAction.PROFILE_PIC_UPDATE:
				let picUpdateUser = this.getState().user;
				picUpdateUser.profilePicture = action.profilePicture;
				return this._updateUser(picUpdateUser);

			case UserAction.BANNER_UPDATE:
				let bannerUpdateUser = this.getState().user;
				bannerUpdateUser.bannerImages = action.bannerImages;
				return this._updateUser(bannerUpdateUser);
			default:
				break;
		}
		return state;
	}
}

export {Session};
export default new SessionStore();


// WEBPACK FOOTER //
// ./src/stores/SessionStore.js